// src/utils/overlayStack.js
//
// Shared stack of open overlays (EntityDrawer, BaseModal).
//
// WHY: each overlay used to lock/unlock `document.body.style.overflow` and listen for
// Escape on its own. With a modal opened from a drawer's footer (e.g. "Inativar" in
// Pacientes), closing the modal set `overflow = ''` while the drawer was still open — the
// page scrolled behind it — and a single Escape could reach both. Now:
//   - only the TOPMOST overlay reacts to Escape;
//   - the body stays locked while ANY overlay is open.

const stack = [];

function syncBodyLock() {
  if (typeof document === "undefined") return;
  document.body.style.overflow = stack.length ? "hidden" : "";
}

/** Registers an overlay as open (on top). Idempotent per token. */
export function openOverlay(token) {
  if (!stack.includes(token)) stack.push(token);
  syncBodyLock();
}

/** Removes an overlay from the stack (closed or unmounted). Idempotent. */
export function closeOverlay(token) {
  const index = stack.indexOf(token);
  if (index !== -1) stack.splice(index, 1);
  syncBodyLock();
}

/** True when `token` is the overlay that should handle Escape right now. */
export function isTopOverlay(token) {
  return stack.length > 0 && stack[stack.length - 1] === token;
}
